import { AuthenticationRepository } from "@src/cloud-connect/node-manager/authentication/authentication-repository";
import { AuthenticationBodyBuilder } from "./authentication-body-builder";

/**
 * Will eventually be replace by context dependency injection
 */
export const buildAuthenticationBody = () => {
  return new AuthenticationBodyBuilder(new AuthenticationRepository()).build();
};
